const dev_mode = window.location.host.search(/\.local|localhost/) > -1;
const noop = () => {};

const konsole = console && console.log ? console : {
  log: noop, dir: noop, error: noop
};

window.console = window.console === "undefined" ? { log: f => f, dir: f => f } : window.console;


const el_liveBind = function el_liveBind(element, event, descendentSelector, callback, evtSetup) {
  var eventNames = event.trim().split(/\s+/);
  // to indicate that they will never invoke preventDefault pass {passive: true}
  evtSetup = typeof evtSetup === 'undefined' ? false : evtSetup;

  for (var i = 0; i < eventNames.length; i++) {
    element.addEventListener(eventNames[i], function(e) {
      if (descendentSelector) {
        let elem = e.target.closest(descendentSelector);
        if (elem && typeof callback === 'function') {
          callback.call(elem, e);
        }
      }
      else {
        callback.call(element, e);
      }
    }, evtSetup);
  }
};

const el_trigger = function el_trigger(el, event, data, bubbles = true, cancelable = false) {
  var eventNames = event.trim().split(/\s+/);
  if (!el || !el.dispatchEvent) {
    konsole.error('Invalid arg0 "el"', el);
    return;
  }
  for (var i = 0; i < eventNames.length; i++) {
    el.dispatchEvent(
      new window.CustomEvent(eventNames[i], {
        bubbles: !!bubbles,
        cancelable: !!cancelable,
        detail: { customEvent: true, customData: data || null }
      })
    );
  }
};


const util = {
  noop, konsole, el_liveBind, el_trigger
};

export {
  noop, konsole, el_liveBind, el_trigger
};

export default util;
